import Router from "next/router";

const push = Router.push.bind(Router);
const replace = Router.replace.bind(Router);

export default { push, replace };
